<template lang="html">
  <article class="container mx-auto max-w-3xl px-4 py-8">
    <h1 class="mb-6 text-3xl font-semibold">
      {{ item!.title }}
    </h1>

    <ContentBodyRenderer :body-json="item!.bodyJson" />

    <ContentGallery :items="images" />
    <ContentDocuments :items="documents" />
  </article>
</template>

<script setup lang="ts">
import ContentBodyRenderer from '../../components/Body/ContentBodyRenderer.vue'
import ContentDocuments from '../../components/Media/ContentDocuments.vue'
import ContentGallery from '../../components/Media/ContentGallery.vue'
import { useContentMedia } from '../../composables/useContentMedia'

definePageMeta({
  name: 'ContentPageDetails',
})

const route = useRoute()
const { service } = useContent()

const slug = computed(() => String(route.params.slug))

const { data: item } = await useAsyncData(
  `content-page-${slug.value}`,
  () => service.getBySlug(slug.value),
  { watch: [slug] },
)

if (!item.value) {
  throw createError({ statusCode: 404, statusMessage: 'Страница не найдена' })
}

const { images, documents } = useContentMedia(item)

useContentSeo(item)
</script>
